import React from "react";
import PlusMultiple from "src/assets/images/website-images/plusMultiSign.png";
import { Skeleton } from "@mui/material"; // MUI Skeleton ke liye import
import { QueryPath } from "src/lib/constans";
import { convertToKebabCase, parseQueryParams } from "src/helpers/helperFunctions";
import { useNavigate } from "react-router-dom";

interface IProps {
  data: any;
  skeleton?: boolean; // Optional prop for skeleton state
}

const TopCategoryCards = ({ data, skeleton = false }: IProps) => {
  const navigate = useNavigate();
  if (skeleton) {
    return (
      <div className="w-full h-[200px] flex flex-col justify-end items-center">
        <div className="w-full h-[70px]  rounded-md relative">
          <Skeleton
            variant="circular"
            width={30}
            height={30}
            className="absolute top-[-10px] left-[-10px]"
          />
          <Skeleton
            variant="rectangular"
            width="95%"
            height={150}
            className="absolute left-1/2 -translate-x-1/2 bottom-0"
          />
        </div>
        <Skeleton
          variant="text"
          width={150}
          height={24}
          className="font-size-20px text-dark-green font-Lexend-SemiBold"
        />
      </div>
    );
  }

  return (
    <div className="w-full xl:h-[200px] h-[160px] flex flex-col justify-end items-center">
      <div className="w-full 2xl:h-[70px] h-[50px] theme-gradient-green-bottom rounded-md relative">
        <img
          src={PlusMultiple}
          alt="Plus Multiple"
          className="w-[25px] 2xl:w-[30px] absolute top-[-10px] left-[-10px]"
        />
        <button className="w-[95%] max-h-[120px] xl:max-h-[150px] flex items-end justify-center absolute left-1/2 -translate-x-1/2 bottom-0" style={{ height: '150px' }} onClick={() => {
          navigate(`/category/${convertToKebabCase(data.mainCategoryName)}?${parseQueryParams({
            [QueryPath.mainCategory]: data.mainCategoryId || "",
            [QueryPath.mainCategoryName]: data.mainCategoryName || "",
          })}`);
        }}>
          <img
            src={data.image}
            alt={data.title}
            className="w-full max-h-full object-contain"
          />
        </button>
      </div>
      <h3 className="font-size-20px text-dark-green font-Lexend-SemiBold whitespace-nowrap">
        {data.title}
      </h3>
    </div>
  );
};

export default TopCategoryCards;
